import React from 'react';

const ImageList=(props)=>{
    const images = props.images.map((image)=>{
		return <img style={{height:'30%',width:'30%',padding:'20px'}} key={image.id} src={image.webformatURL} alt="" />
	})

	return(
		 <div style={{display:'flex',flexWrap:'wrap',justifyContent : 'center'}}>
		  {images}
		 </div>
		)
}

export default ImageList; 